interface IGetYandexData<T> {
  request: Promise<T>;
  onSuccess: (data: T) => void;
  onError: (error: Error) => void;
}

export const getYandexData = async <T>({ request, onSuccess, onError }: IGetYandexData<T>) => {
  try {
    const yandexData = await request;

    onSuccess(yandexData);
  } catch (e) {
    onError(e);
  }
};
